import './App.css';
import React, {useContext} from "react";
import {Routes, Route, BrowserRouter} from "react-router-dom";
import ValidatorCallbackSdk from "./modules/validatorCallbackSdk";
import ValidatorCameraConfig from "./modules/validatorCameraConfig/camera";
import ConfigRoutes from "./modules/configRoutes";
import CardCaptureV2 from './modules/cardCapture/v2/camera';
import CardCaptureV1 from './modules/cardCapture/v1/camera';
import CardCaptureV1OBG from './modules/cardCapture/v1-obg/camera';
import LivenessV5 from "./modules/liveness/v5";
import LivenessV6Wrapper from "./modules/liveness/v6";
import CardCaptureV6, {WrapperCardCaptureV6} from './modules/cardCapture/v6/camera';
import CardCaptureV6WhateMarks from './modules/cardCapture/v6-whatemarks/camera';
import CardCaptureV7, {WrapperCardCaptureV7} from './modules/cardCapture/v7/camera';
import CardCaptureV8, {WrapperCardCaptureV8} from './modules/cardCapture/v8/camera';
import {ConfigContext, ConfigProvider} from './context/ConfigContext';
import LivenessV2 from './modules/liveness/v2';
import LivenessDebug from './modules/liveness/debug';
import CardCaptureDebug from './modules/cardCapture/debug/camera';
import Manager from "./modules/manager";
import ManagerWrapper from "./modules/manager";
import LivenessV5Wraper from "./modules/liveness/v5";
import CardCaptureV6Wrapper from "./modules/cardCapture/v6/camera";
import {WrapperCameraValidator} from "./modules/cardCapture/cameraValidator/camera";
import {WrapperSocketCardCaptureV6} from "./modules/cardCapture/sockets/camera";
import LivenessV5SocketWraper from "./modules/liveness/socket";
import LivenessV7Wrapper from "./modules/liveness/v7";
import LivenessV8Wrapper from "./modules/liveness/v8";
import {WrapperTestCamera} from "./modules/testCamera/camera";
import DniCaptureComponent from "./modules/cardCapture/dniCaptureComponent";
import { ExtractMetricsWrapper } from "./modules/extractMetrics";

export const routes = [
    {
        path: "/card-capture/v1",
        element: (
            <WrapperCardCaptureV7 />
        ),
        private: false,
        name: 'Card capture v1',
        innerPath: "/?code=20234d2b63ad83b4&showError=true&codeTransaction=20234d2b63ad83b4&urlServiceLiveness=https://vsts-liveness-bknd-dev.ado-tech.com&projectName=LuloBankQA"
    },
    {
        path: "/card-capture/v1-obg",
        element: (
            <CardCaptureV1OBG />
        ),
        private: false,
        name: 'Card capture v1 obg',
        innerPath: "/?code=20234d2b63ad83b4&showError=true&codeTransaction=20234d2b63ad83b4&urlServiceLiveness=https://vsts-liveness-bknd-dev.ado-tech.com&projectName=LuloBankQA"
    },
    {
        path: "/card-capture/v2",
        element: (
            <CardCaptureV2 />
        ),
        private: false,
        name: 'Card capture v2 sin loader',
        innerPath: "/?code=20234d2b63ad83b4&showError=true&codeTransaction=20234d2b63ad83b4&urlServiceLiveness=https://vsts-liveness-bknd-dev.ado-tech.com&projectName=LuloBankQA"
    },
    {
        path: "/card-capture/v6",
        element: (
            <WrapperCardCaptureV6 />
        ),
        private: false,
        name: 'Card capture v6',
        innerPath: "/?code=20234d2b63ad83b4&showError=true&codeTransaction=20234d2b63ad83b4&urlServiceLiveness=https://vsts-liveness-bknd-dev.ado-tech.com&projectName=LuloBankQA"
    },
    {
        path: "/card-capture/sockets/v6",
        element: (
            <WrapperSocketCardCaptureV6 />
        ),
        private: false,
        name: 'Card capture socket v6',
        innerPath: "/?code=20234d2b63ad83b4&showError=true&codeTransaction=20234d2b63ad83b4&urlServiceLiveness=https://vsts-liveness-bknd-dev.ado-tech.com&projectName=LuloBankQA"
    },
    {
        path: "/card-capture/v7",
        element: (
            <WrapperCardCaptureV7 />
        ),
        private: false,
        name: 'Card capture v7 MediaPipe',
        innerPath: "/?code=20234d2b63ad83b4&showError=true&codeTransaction=20234d2b63ad83b4&urlServiceLiveness=https://vsts-liveness-bknd-dev.ado-tech.com&projectName=LuloBankQA&urlTracer=https://api-dev.ado-tech.com/api/EventTracer/&processId=f3437911-1b30-48e2-9fb8-80964620905d"
    },
    {
        path: "/card-capture/v8",
        element: (
            <WrapperCardCaptureV8 />
        ),
        private: false,
        name: 'Card capture v8 MediaPipe',
        innerPath: "/?code=20234d2b63ad83b4&showError=true&codeTransaction=20234d2b63ad83b4&urlServiceLiveness=https://vsts-liveness-bknd-dev.ado-tech.com&projectName=LuloBankQA"
    },
    {
        path: "/card-capture/v6-whatemarks",
        element: (
            <CardCaptureV6WhateMarks />
        ),
        private: false,
        name: 'Card capture v6 whatemarks',
        innerPath: "/?code=20234d2b63ad83b4&showError=true&codeTransaction=20234d2b63ad83b4&urlServiceLiveness=https://vsts-liveness-bknd-dev.ado-tech.com&projectName=LuloBankQA"
    },
    {
        path: "/card-capture/debug",
        element: (
            <CardCaptureDebug/>
        ),
        private: false,
        name: 'Card capture debugger',
        innerPath: "/?code=20234d2b63ad83b4&showError=true&codeTransaction=20234d2b63ad83b4&urlServiceLiveness=https://vsts-liveness-bknd-dev.ado-tech.com&projectName=LuloBankQA"
    },
    {
        path: "/liveness/v1",
        element: (
            <LivenessV5Wraper />
        ),
        private: false,
        name: 'Liveness v1',
        innerPath: "/?code=27761f990fb346a48de3d58a675cd339&showError=true&codeTransaction=27761f990fb346a48de3d58a675cd339&urlServiceLiveness=https://liveness-bff-v3-qa.ado-tech.com&projectName=BancoBogotaSTG&debug=false&urlTracer=https://api-dev.ado-tech.com/api/EventTracer/&processId=f3437911-1b30-48e2-9fb8-80964620905d"
    },
    {
        path: "/liveness/socket/v1",
        element: (
            <LivenessV5SocketWraper />
        ),
        private: false,
        name: 'Liveness socket v1',
        innerPath: "/?code=27761f990fb346a48de3d58a675cd339&showError=true&codeTransaction=27761f990fb346a48de3d58a675cd339&urlServiceLiveness=https://liveness-bff-v3-qa.ado-tech.com&projectName=BancoBogotaSTG&debug=false&urlTracer=https://api-dev.ado-tech.com/api/EventTracer/&processId=f3437911-1b30-48e2-9fb8-80964620905d"
    },
    {
        path: "/liveness/v2-old",
        element: (
            <LivenessV2/>
        ),
        private: false,
        name: 'Liveness v2 (Old)',
        innerPath: "/?code=20234d2b63ad83b4&showError=true&codeTransaction=20234d2b63ad83b4&urlServiceLiveness=https://vsts-liveness-bknd-dev.ado-tech.com&projectName=LuloBankQA"
    },
    {
        path: "/liveness/v6",
        element: (
            <LivenessV6Wrapper/>
        ),
        private: false,
        name: 'Liveness v6',
        innerPath: "/?code=4dd8edfd029e4d78be08dc59c2d37820&showError=true&codeTransaction=4dd8edfd029e4d78be08dc59c2d37820&urlServiceLiveness=https://engine-qa.ado-tech.com&projectName=testado"
    },
    {
        path: "/liveness/v7",
        element: (
            <LivenessV7Wrapper/>
        ),
        private: false,
        name: 'Liveness v7 (SDK)',
        innerPath: "/?code=27761f990fb346a48de3d58a675cd339&showError=true&codeTransaction=27761f990fb346a48de3d58a675cd339&urlServiceLiveness=https://liveness-bff-v3-qa.ado-tech.com&projectName=BancoBogotaSTG&debug=false&urlTracer=https://api-dev.ado-tech.com/api/EventTracer/&processId=f3437911-1b30-48e2-9fb8-80964620905d&language=es"
    },
    {
        path: "/liveness/v8",
        element: (
            <LivenessV8Wrapper/>
        ),
        private: false,
        name: 'Liveness v8',
        innerPath: "/?code=27761f990fb346a48de3d58a675cd339&showError=true&codeTransaction=27761f990fb346a48de3d58a675cd339&urlServiceLiveness=https://liveness-bff-v3-qa.ado-tech.com&projectName=LuloBankQA&debug=false&urlTracer=https://api-dev.ado-tech.com/api/EventTracer/&processId=f3437911-1b30-48e2-9fb8-80964620905d"

    },
    {
        path: "/liveness/debug",
        element: (
            <LivenessDebug/>
        ),
        private: false,
        name: 'Liveness debugger',
        innerPath: "/?code=20234d2b63ad83b4&showError=true&codeTransaction=20234d2b63ad83b4&urlServiceLiveness=https://vsts-liveness-bknd-dev.ado-tech.com&projectName=LuloBankQA"
    },
    {
        path: "/validatorCallbackSdk",
        element: (
            <ValidatorCallbackSdk />
        ),
        private: false,
        name: 'validator Callback Sdk',
        innerPath: ""
    },
    {
        path: "/validatorCameraConfig",
        element: (
            <ValidatorCameraConfig />
        ),
        private: false,
        name: 'validador camara',
        innerPath: ""
    },
    {
        path: "/configRoutes",
        element: (
            <ConfigRoutes />
        ),
        private: false,
        name: 'Routes',
        innerPath: ""
    },
    {
        path: "/manager",
        element: (
            <ManagerWrapper />
        ),
        private: false,
        name: 'Routes',
        innerPath: ""
    },
    {
        path: "/camera-validator",
        element: (
            <WrapperCameraValidator />
        ),
        private: false,
        name: 'Routes',
        innerPath: ""
    },
    {
        path: "/test-camera",
        element: (
            <WrapperTestCamera />
        ),
        private: false,
        name: 'test camera',
        innerPath: ""
    },
    {
        path: "/dni-capture",
        element: (
            <DniCaptureComponent />
        ),
        private: false,
        name: 'test camera dni',
        innerPath: ""
    },
    {
        path: "/extract-metrics",
        element: (
            <ExtractMetricsWrapper />
        ),
        private: false,
        name: 'Extraer Métricas',
        description: 'Extrae métricas del dispositivo usando el SDK de Liveness',
        innerPath: ""
    },
]

function App() {
    return (
        <div>
            <Routes>
                {routes.map(route => (
                    <Route
                        key={route.path}
                        path={route.path}
                        element={<RouteWithConfig element={route.element} />}
                    />
                ))}
            </Routes>
        </div>
    );
}

function RouteWithConfig({element}) {
    return (
        <ConfigProvider>
            <InnerRoute element={element} />
        </ConfigProvider>
    )
}

function InnerRoute({element}) {
    const { loading } = useContext(ConfigContext);
    if (loading) {
        return null;
    }
    return element;
}

export default function AppWrapper() {
    return (
        <BrowserRouter>
            <App />
        </BrowserRouter>
    )
}
